'use client'

import { useEffect, useState } from 'react'
import useSWR from 'swr'
import Wallet from '@/utils/wallet'
import useLoggedIn from './useLoggedIn'
import { fetchIncomingOffers, isActiveOffer } from '@/utils/offer-inbox'

/** One shared wallet read for all item actions, rather than a request per card. */
export default function useActiveItemOffer(itemId: string, enabled = true) {
	const loggedIn = useLoggedIn()
	const address = loggedIn && enabled ? Wallet.getTaprootAddress() : null
	const { data } = useSWR(
		address ? ['offers:incoming', address] : null,
		([, address]) => fetchIncomingOffers(address),
		{ refreshInterval: 30000 }
	)
	const [now, setNow] = useState(Date.now)
	const offer =
		data?.sent?.find(
			(o) =>
				o.scope === 'item' &&
				o.inscription_id === itemId &&
				o.buyer_address === address &&
				isActiveOffer(o, now)
		) || null
	const expiresAt = offer?.expires_at
	useEffect(() => {
		if (!expiresAt) return
		const timer = setTimeout(
			() => setNow(Date.now()),
			Math.min(2147483647, Math.max(0, Date.parse(expiresAt) - Date.now() + 1))
		)
		return () => clearTimeout(timer)
	}, [expiresAt, now])
	return offer
}
